export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/instapay-logo.d9e49f8b.svg","height":20,"width":30,"blurWidth":0,"blurHeight":0};